import { supabase } from '../lib/supabaseClient';

export async function fetchShowRecommendations(website_id, sortMode = 'date') {
  // Step 1: Get the podcast by website_id
  const { data: podcast, error: podcastError } = await supabase
    .from('groups')
    .select('id, name, image_url')
    .eq('website_id', website_id)
    .single();

  if (podcastError || !podcast) {
    // Silently return empty array for invalid website_ids (user will be redirected anyway)
    console.log(`No podcast found for website_id "${website_id}"`);
    return [];
  }

  console.log(`Found podcast: ${podcast.name} (ID: ${podcast.id})`);

  // Step 2: Fetch recommendations with upvote counts using RPC
  let recommendations, recsError;
  
  if (sortMode === 'best') {
    // Use the hot recommendations function for "Popular" sorting
    const { data, error } = await supabase
      .rpc('get_hot_recommendations', {
        p_podcast_id: podcast.id,
        limit_count: 1000,
        offset_count: 0
      });
    recommendations = data;
    recsError = error;
  } else {
    // Use date sorting for everything else
    const { data, error } = await supabase
      .rpc('get_recommendations_with_upvotes_sorted', {
        podcast_id_param: podcast.id,
        sort_by: 'date'
      });
    recommendations = data;
    recsError = error;
  }

  if (recsError) {
    console.error("Recommendations fetch error:", recsError);
    return {
      recommendations: [],
      podcastName: podcast.name,
      podcastImage: podcast.image_url
    };
  }

  if (!recommendations || recommendations.length === 0) {
    console.log("No recommendations found for this podcast");
    return {
      recommendations: [],
      podcastName: podcast.name,
      podcastImage: podcast.image_url
    };
  }

  console.log(`✅ Recommendations with upvotes fetched: ${recommendations.length}`);

  const formattedRecommendations = recommendations
    .map((rec, index) => {
      return {
        id: `rec${index}`,
        fields: {
          id: rec.id,
          Title: "", // No episodes, so no episode title
          Link: rec.url || null,
          Recommendation: rec.name || "",
          Date: rec.created_at || "",
          ImageUrl: rec.image_url || "",
          upvoteCount: rec.upvote_count || 0, // Include upvote count
          recommenderId: rec.recommender_id || null, // Include recommender ID
          recommenderName: rec.recommender_name || null, // Include recommender name
        }
      };
    });

  // Return both the recommendations and the podcast name
  return {
    recommendations: formattedRecommendations,
    podcastName: podcast.name,
    podcastImage: podcast.image_url
  };
}
